// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__3wywK","boxTitle":"Qualiphy_boxTitle__auDSF","box":"Qualiphy_box__1vQnC","toggleWrap":"Qualiphy_toggleWrap__3mbUq"};